import { useState, useEffect, useCallback } from 'react';

type Theme = 'light' | 'dark' | 'system';

/**
 * Theme hook — respects dark mode set by DarkEntryWrapper.
 * Entry pages (login, signup, checkout) are forced dark via DarkEntryWrapper.
 * Authenticated pages are light (DarkEntryWrapper removes .dark on unmount).
 * This hook observes the current state — it does not override DarkEntryWrapper.
 */
export function useTheme() {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    // Observe class changes on document root (DarkEntryWrapper toggles .dark)
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const setTheme = useCallback((_t: Theme) => {
    // Theme is controlled by DarkEntryWrapper, not user toggle
  }, []);

  return {
    theme: (isDark ? 'dark' : 'light') as Theme,
    setTheme,
    isDark,
  };
}
